import { types } from "mobx-state-tree";

export const currentUserModel = types.model({
  email: types.maybeNull(types.string),
  default_tool: types.maybeNull(types.string),
  jwt_token: types.maybeNull(types.string),
  free_trial_left: types.maybeNull(types.number),
  name: types.maybeNull(types.string),
  plan: types.maybeNull(types.string),
});

export const usersType = types.model({
  account_holder: types.maybeNull(types.string),
  plan: types.maybeNull(types.string),
  country: types.maybeNull(types.string),
  date_joined: types.maybeNull(types.string),
  user_email: types.maybeNull(types.string),
  entity: types.maybeNull(types.string),
  entity_type: types.maybeNull(types.string),
  "Chat Credits used / Chat Credits purchased": types.maybeNull(types.string),
  "Assistant Credits used / Assistant Credits purchased": types.maybeNull(
    types.string,
  ),
  last_logged_in: types.maybeNull(types.string),
});

export const allUsersType = types.model({
  "account holders": types.maybeNull(types.array(usersType)),
  "total users": types.maybeNull(types.number),
});

export const tokenInfoType = types.model({
  str: types.maybeNull(types.string),
  creditsPurchased: types.maybeNull(types.number),
  creditsUsed: types.maybeNull(types.number),
});
